import App from './TheApp.svelte';

const TheApp = new App({
  target: document.body,
});

export default TheApp;
